import(/* webpackMode: "eager" */ "/vercel/path0/app/[locale]/not-found.tsx");
